const STORAGE_KEY = 'mibeko_chat_conversations';
const MAX_CONVERSATIONS = 30;

export const loadConversations = () => {
  try {
    const list = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

export const saveConversation = (convo) => {
  try {
    const list = loadConversations();
    const existing = list.find((c) => c.id === convo.id);
    const entry = {
      ...convo,
      createdAt: existing?.createdAt || convo.updatedAt,
    };
    const rest = list.filter((c) => c.id !== convo.id);
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify([entry, ...rest].slice(0, MAX_CONVERSATIONS))
    );
  } catch {
    // stockage indisponible : l'historique est simplement desactive
  }
};

export const deleteConversation = (id) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(loadConversations().filter((c) => c.id !== id))
    );
  } catch {
    // ignore
  }
};
